import { Shield, Award, Clock, Headphones } from "lucide-react";

const badges = [
  { icon: Shield, label: "100% Australian Owned", desc: "Local support & service" },
  { icon: Award, label: "Owned by Security Agents", desc: "With nearly 20 years of experience" },
  { icon: Clock, label: "24/7 Monitoring", desc: "Round-the-clock surveillance" },
  { icon: Headphones, label: "Dedicated Support", desc: "Expert team on call" },
];

export default function TrustBadges() {
  return (
    <section className="border-y border-border bg-navy-deep py-8">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                <badge.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground">{badge.label}</p>
                <p className="text-xs text-muted-foreground">{badge.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
